import React, { useMemo, useState } from 'react'
import { Box } from '@maui/elements'
import { AssociationDetailsView, TargetsDetailsView, SummaryDetailsView, GroupAssociationDetailsView, RecentActivityView } from '../'
import { useScrollToRefs } from '@/hooks/useScrollToRefs'
import { normalizeActor } from '@/api/normalizers'
import { AttributionScopeProvider } from '@/hooks/useAttributionScope'
import { ViewObjectLinks } from '@/components/modals/ViewObjectLinks'

export const checkFreemiumUser = actorData => actorData && Object.values(actorData).some(value => value === 'redacted')

function ModalDetails({ actorData, id, actorHistory, ...props }) {
  const isFreemiumUser = checkFreemiumUser(actorData)
  const [expanded, setExpanded] = useState({ malwareList: false, industriesList: false })
  const [refs, scrollToNamedRef] = useScrollToRefs(['associationsList', 'targetsList'])

  const scrollToAndSetExpanded = (refName, listName) => {
    setExpanded({ ...expanded, [listName]: true })
    scrollToNamedRef(refName)
  }

  const actor = useMemo(() => {
    if (!actorData) return null
    return normalizeActor(actorData)
  }, [actorData])

  return (
    <Box m="-16px" {...props}>
      <AttributionScopeProvider>
        <SummaryDetailsView
          id={id}
          actorData={actor}
          headerSlot={actorData && <ViewObjectLinks path={`/actors/${actorData.id}`} />}
        />
        {!isFreemiumUser &&
          <RecentActivityView id={id} actorData={actor} inModal scrollToAndSetExpanded={scrollToAndSetExpanded} />
        }
        <GroupAssociationDetailsView id={id} actorData={actor} ref={refs[0]} actorHistory={actorHistory}/>
        <AssociationDetailsView id={id} actorData={actor} ref={refs.associationsList} expanded={expanded} />
        <TargetsDetailsView id={id} actorData={actorData} ref={refs.targetsList} expanded={expanded} />
      </AttributionScopeProvider>
    </Box>
  )
}

export default ModalDetails
